import { MetricProperty } from "src/components";
import { ActionItemDetailDto, useAddActionItemMetric, useRemoveMetricFromCollection } from "src/http";
import { lexorank } from "src/utilities";

interface Props {
  actionItem: ActionItemDetailDto;
}

const ActionItemMetricProperty = (props: Props) => {
  const { mutate: addMetric, isLoading: isAddingMetric } = useAddActionItemMetric();
  const { mutate: removeMetric, isLoading: isRemovingMetric } = useRemoveMetricFromCollection();

  function handleMetricAdded(metricGuid: string) {
    addMetric({
      actionItemGuid: props.actionItem.guid,
      planGuid: props.actionItem.teamPlanSection.planGuid,
      metricCollectionGuid: props.actionItem.metricCollectionGuid,
      metricGuid: metricGuid,
      sortOrder: lexorank.getNextRank(),
    });
  }

  function handleMetricRemoved(metricGuid: string) {
    if (props.actionItem.metricCollectionGuid == null) {
      return;
    }

    removeMetric({
      metricCollectionGuid: props.actionItem.metricCollectionGuid,
      metricGuid: metricGuid,
    });
  }

  return (
    <MetricProperty
      metricCollectionGuid={props.actionItem.metricCollectionGuid}
      userCanEdit={props.actionItem.userCanEdit}
      disabled={isAddingMetric || isRemovingMetric}
      onMetricAdded={handleMetricAdded}
      onMetricRemoved={handleMetricRemoved}
    />
  );
};

export { ActionItemMetricProperty };
